import { HTTP } from "@/services/HTTPService";
import { BACKOFFICE } from "@/services/HTTPService";
import store from "../../store";

export default {
  async getMimkList() {
    try {
      const response = await BACKOFFICE.get(
        "/staff_list/?staff_type=mimk_teacher_based"
      );
      return response.data;
    } catch (err) {
      if (err.response.status === 404) {
        return [];
      }
    }
  },
  async getMimkStatus(dateTime) {
    const segmentState = store.state.user.segment;
    const params = {
      date_time: dateTime,
      tz_offset: segmentState.tz_offset,
      segment: segmentState.id,
    };
    const response = await HTTP.get("/mimk/status/", { params });
    return response.data;
  },
  getStartPath() {
    const studentId = `students/student_${store.state.user.user.studentInfo.student_id}`;
    if (!studentId) {
      this.$router.replace("/auth");
    } else {
      return studentId;
    }
  },
  async sendTcReport(data) {
    const segmentState = store.state.user.segment;
    const sendingData = {
      tz_offset: segmentState.tz_offset,
      ...data,
    };
    const response = await HTTP.post("/mimk/report/", sendingData);
    return response.data;
  },
  async downloadReport(reportId) {
    const response = await HTTP.get(`/mimk/report/for-client/${reportId}`, { responseType: 'blob' })
    window.open(URL.createObjectURL(response.data));
  },
  async getReporMcData(trialClass) {
    try {
      const response = await HTTP.get(
        `/mimk/report/questions?segment=${trialClass.extraInformation.segment}`
      );
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
  async getMimkAward() {
    try {
      console.log(store.state.user.segmentsList);
      const userState = store.state.user;
      const listSegments = [];

      store.state.user.segmentsList.map((el) => {
        listSegments.push(el.id);
      });

      const params = {
        segment: listSegments.join(","),
        mimk: userState.user.id,
      };
      const response = await HTTP.get("/mimk/award/", { params });
      console.log(response.data);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  },
};
